<template>
  <div>
    <div class="coming-soon">
      <b-container>
        <b-row>
          <b-col cols="3">
            <b-avatar src="/assets/_birthday/tink.jpeg" size="10rem"></b-avatar>
          </b-col>
          <b-col>
            <b-row style="margin-bottom: 15px">
              <b-col cols="3">
                <strong>d3rriana</strong>
              </b-col>
              <b-col cols="3">
                <b-button
                    rounded style="background-color: #b2ac88; color:#000000; border: none"
                    @click="handleAddMemoryClick"
                >
                  Follow
                </b-button>
              </b-col>
              <b-col cols="3">
                <b-button

                    rounded
                    style="background-color: #b2ac88; color:#000000; border: none"
                    @click="handleAddMemoryClick"
                >
                  Message
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <strong> {{ filteredMemoriesApproved.length}} memories</strong>
              </b-col>
              <b-col cols="6">
                <strong>1,630 friends</strong>
              </b-col>
              <b-col>
              </b-col>
            </b-row>
            <b-row style="margin-top:15px">
              <b-col cols="6">
                <h6
                    @click="handleAddMemoryClick"
                    style="color: #000000;cursor: pointer;"
                >
                  <b-icon
                      icon="instagram"
                      animation="throb"
                  />
                  Click to add a Memory
                </h6>
              </b-col>
              <b-col cols="6">

              </b-col>
              <b-col>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col>
            <b-avatar
                v-for="(aStory, i) in stories"
                :src="aStory.imgURL"
                size="5rem"
                style="margin-left: 15px;"
                :key="`story-${i}`"
            />
          </b-col>
        </b-row>
        <hr />
        <b-tabs align="center">
          <b-tab
              active
          >
            <template #title>
              <h6 style="color: #000000">
                <b-icon
                    icon="grid3x3"
                />
                GRID
              </h6>
            </template>
            <b-row style="margin-top: 15px;">
              <b-col sm="3" v-for="(aMemory, i) in filteredMemoriesApproved">
                <memory-card
                    :key="`mem-${i}`"
                    :memory-entity="aMemory"
                />
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="Tagged">
            <template #title>
              <h6 style="color: #575151">
                <b-icon
                    icon="view-stacked"
                />
                ROWS
              </h6>
            </template>
            <b-card-text>
              <data-table
                  style="margin-top: 15px;"
                  :items="filteredMemoriesApproved"
              />
            </b-card-text>
          </b-tab>
        </b-tabs>
        <memories-row
            v-if="false"
            style="margin-top:25px;
            margin-bottom:25px; height: 500px;"

        />
      </b-container>
    </div>
    <add-edit-item-modal
        :ref="addEditItemModalId"
        :item-status-modal-id="addEditItemModalId"
        :profile="null"
        @item-added="handleItemAdded"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import config from "@/assets/_config.json";
import MemoriesRow from "@/components/home/MemoriesRow";
import MemoryCard from "./memoryCard";
import RecordViews from "@/mixins/RecordViews";
import moment from "moment";
import AddEditItemModal from "./addEditItemModal";
import DataTable from "./dataTable";

export default {
  name: "Home_Site",
  components: {
    AddEditItemModal,
    DataTable,
    MemoriesRow,
    MemoryCard
  },
  mixins: [RecordViews],
  computed: {
    ...mapGetters({
      allMemories: "admin/memories"
    }),
    filteredMemoriesApproved(){
      return this.allMemories && Array.isArray(this.allMemories)?
          this.allMemories.filter(aMemory=>{
        return aMemory.status != 'rejected';
      }): [];
    }
  },
  created() {
    this.getMemories();
  },
  methods: {
    getMemories(){
      this.$store.dispatch("admin/getMemories").then((res)=>{
        console.log(res);
      });
    },
    formatDate(date) {
      return date
          ? moment(date.toDate()).format("MMMM DD, YYYY h:MM a")
          : "N/A";
    },
    handleAddMemoryClick(){
      debugger;
      if (this.$refs[this.addEditItemModalId].hasOwnProperty("handleAddItem")) {
        this.$refs[this.addEditItemModalId].handleAddItem();
      }
    },
    handleItemAdded(item){
      this.$store.dispatch("user/showNotification", {
        title: `A Memory Added ${ item && item.name ? item.name: ""} !'}`,
        description: `Your item has been added`,
        variant: "success"
      });
      this.getMemories();
    }
  },
  mounted() {},
  data() {
    return {
      id: "success-modal",
      addEditItemModalId: "add-edit-status-modal-now",
      config,
      loading: false,
      stories: [
        {
          title:'My Friends',
          imgURL:'/assets/_birthday/dandd.png'
        },
        {
          title:'My Friends',
          imgURL:'/assets/_birthday/youngtink.jpeg'
        },
        {
          title:'My Friends',
          imgURL:'/assets/_birthday/game.jpg'
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.coming-soon {
  padding-top: 100px;
  background: #FE828C;
}
</style>
